export default __webpack_public_path__ + "static/about-vig-logo-a8d95ebab5ffea7f10cbc0b2d4648c30.svg";